import JobDetail from './JobDetail';

/**
 * JobDetailPage - Page wrapper for the Job detail view
 * 
 * All necessary providers (Customer, Services, Business, Jobs, Employees, Invoices)
 * are provided at the route level in App.tsx
 */
export default function JobDetailPage() {
  return <JobDetail />;
}